/**
 * @generated SignedSource<<75b1049b8f583c16e2eb65fd1fb00adb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightPriceHistoryTable_history$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"FlightPriceHistoryRow_entry">;
    };
  }>;
  readonly pageInfo: {
    readonly total: number;
    readonly " $fragmentSpreads": FragmentRefs<"Table_pageInfo">;
  };
  readonly " $fragmentType": "FlightPriceHistoryTable_history";
};
export type FlightPriceHistoryTable_history$key = {
  readonly " $data"?: FlightPriceHistoryTable_history$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightPriceHistoryTable_history">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightPriceHistoryTable_history",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightPriceEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlightPrice",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "FlightPriceHistoryRow_entry"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Table_pageInfo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FlightPriceConnection",
  "abstractKey": null
};

(node as any).hash = "276c516da98159c4cd71ba46ff853457";

export default node;
